var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0883 60.4875C62.6633 60.4875 56.3383 60.4875 49.9883 60.4875C49.9883 50.6 49.9883 40.7375 49.9883 30.725C56.3758 40.7 62.7133 50.55 69.0883 60.4875Z",
    fill: "#448AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0625 62.95C43.325 62.95 56.55 62.95 69.8875 62.95C69.4 63.3625 68.9875 63.7125 68.575 64.0625C66.4625 65.8375 64.35 67.6125 62.225 69.375C62.0625 69.5125 61.8125 69.6 61.6 69.6C52.6125 69.6125 43.6375 69.6125 34.65 69.6C34.475 69.6 34.2125 69.5 34.125 69.3625C32.7875 67.3 31.4625 65.225 30.1375 63.15C30.1125 63.1 30.1 63.05 30.0625 62.95Z",
    fill: "#448AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 60.4875C37.325 52.5 43.1 44.575 48.95 36.5625C48.975 36.7875 49 36.9 49 37.0125C49 44.6875 49 52.35 49.0125 60.025C49.0125 60.35 48.975 60.525 48.5625 60.525C43.0125 60.5125 37.4625 60.5125 31.9125 60.5125C31.8 60.5125 31.6875 60.5 31.5 60.4875Z",
    fill: "#448AFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.ebdabc175efa61a400c1c69139db7fbd.svg";
export { ForwardRef as ReactComponent };